package org.matthewo.hooks

import js.coroutines.awaitCancellation
import react.useEffectOnce
import react.useState
import web.events.Event
import web.events.EventType
import web.events.addEventListener
import web.events.removeEventListener
import web.window.window

external interface WindowSize {
    val width: Int
    val height: Int
}

fun useWindowSize(): WindowSize {
    var size by useState<WindowSize> {
        object : WindowSize {
            override val width = window.innerWidth
            override val height = window.innerHeight
        }
    }

    useEffectOnce {
        val listener = { _: Event ->
            size = object : WindowSize {
                override val width = window.innerWidth
                override val height = window.innerHeight
            }
        }

        window.addEventListener(EventType("resize"), listener)
        awaitCancellation {
            window.removeEventListener(EventType("resize"), listener)
        }
    }

    return size
}
